export const RulerIcon = () => {
	return (
		<svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="28" rx="8" fill="white" />
			<g clipPath="url(#clip0_13508_123779)">
				<path
					d="M17.6665 14.3332L18.9999 12.9999M15.6665 12.3332L16.9999 10.9999M13.6665 10.3332L14.9999 8.99987M19.6665 16.3332L20.9999 14.9999M22.1999 16.1999C22.349 16.3485 22.4674 16.5251 22.5481 16.7196C22.6289 16.9141 22.6705 17.1226 22.6705 17.3332C22.6705 17.5438 22.6289 17.7523 22.5481 17.9468C22.4674 18.1413 22.349 18.3179 22.1999 18.4665L20.4665 20.1999C20.3179 20.349 20.1413 20.4674 19.9468 20.5481C19.7523 20.6289 19.5438 20.6705 19.3332 20.6705C19.1226 20.6705 18.9141 20.6289 18.7196 20.5481C18.5251 20.4674 18.3485 20.349 18.1999 20.1999L9.79987 11.7999C9.50024 11.4988 9.33203 11.0913 9.33203 10.6665C9.33203 10.2418 9.50024 9.83428 9.79987 9.5332L11.5332 7.79987C11.8343 7.50024 12.2418 7.33203 12.6665 7.33203C13.0913 7.33203 13.4988 7.50024 13.7999 7.79987L22.1999 16.1999Z"
					stroke="currentColor"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_13508_123779">
					<rect width="16" height="16" fill="white" transform="translate(8 6)" />
				</clipPath>
			</defs>
		</svg>
	)
}
